import RestModule from "../../vue-ocom/store/RestModule.js";
import schema from "./schema/index";

import * as CONFIG from "../../config.js";
import RestActionModule from "vue-ocom/store/RestActionModule";
var root_url = CONFIG.root_url;

const FormEntrySignOffModule = RestModule(
  root_url + "/forms247/form_entry_sign_off/",
  schema.FormEntrySignOff
);
const FormTemplateVersionModule = RestModule(
  root_url + "/forms247/form_template_version/",
  schema.FormTemplateVersion
);
const FormTemplateModule = RestModule(
  root_url + "/forms247/form_template/",
  schema.FormTemplate
);
const FormEntryModule = RestModule(
  root_url + "/forms247/form_entry/",
  schema.FormEntry
);
const FormEntryFileModule = RestModule(
  root_url + "/forms247/form_entry_file/",
  schema.FormEntryFile
);
const FormTemplatePermissionModule = RestModule(
  root_url + "/forms247/form_template_permission/",
  schema.FormTemplatePermission
);
const FormEntryWorkflowStateModule = RestModule(
  root_url + "/forms247/form_entry_workflow_state/",
  schema.FormEntryWorkflowState
);

const FormEntryGetButtonsModule = RestActionModule(root_url + "/forms247/v1/");
//Add more modules here if needed. These will automatically be included and available in main store.

export default {
  FormEntrySignOffModule,
  FormTemplateVersionModule,
  FormTemplateModule,
  FormEntryModule,
  FormEntryFileModule,
  FormTemplatePermissionModule,
  FormEntryWorkflowStateModule,
  FormEntryGetButtonsModule,
};
